{
  "slug": "iq-vs-intelligence",
  "title": "IQ vs intelligence: are they the same?",
  "description": "Understand the difference between a standardized IQ score and the broader concept of human intelligence.",
  "summary": "Intelligence is a broad psychological concept. IQ is a standardized estimate based on performance on selected cognitive tasks.",
  "sections": [
    {
      "heading": "Intelligence is broader than one score",
      "paragraphs": [
        "Psychologists use intelligence to discuss the capacity to learn, reason, solve problems, adapt, and use knowledge. Theories differ: some emphasize a general factor, while others describe multiple broad or specialized abilities.",
        "Intelligence operates in real environments. Practical knowledge, creativity, persistence, and cultural experience shape how people solve meaningful problems."
      ]
    },
    {
      "heading": "IQ is a measurement tool",
      "paragraphs": [
        "An IQ score summarizes a sample of cognitive performance relative to an age-based norm group. Well-designed tests can predict some educational and occupational outcomes, but prediction is statistical rather than destiny.",
        "No test observes every form of intelligent behavior. Tasks, scoring, norms, language, and testing conditions define what a result can support."
      ]
    },
    {
      "heading": "Use the score at the right level",
      "paragraphs": [
        "IQ is useful when the question matches the evidence, such as describing patterns of cognitive strengths and needs in a comprehensive assessment. It is less useful as shorthand for talent, character, creativity, or value.",
        "A thoughtful interpretation combines scores with history, behavior, environment, goals, and other relevant information."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does IQ measure all intelligence?",
      "answer": "No. It samples important cognitive abilities but does not exhaust creativity, practical judgment, wisdom, motivation, or emotional skill."
    },
    {
      "question": "Can someone be intelligent with an average IQ?",
      "answer": "Yes. An average composite can coexist with specific strengths, expertise, creativity, or effective practical problem solving."
    }
  ],
  "related": [
    "what-is-iq",
    "iq-vs-eq",
    "how-is-iq-measured",
    "general-intelligence-g-factor-explained"
  ]
}
